import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { Card } from '@material-ui/core';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import { AppSnackbar, CardContent, CardTitle } from '@sierralabs/core-ui';
import { InlineForm, InlineFormik, InlineTextField } from '@sierralabs/react-material-ui-formik';
import { useUpdateFormTemplate } from '../FormTemplate.hooks';
import { FormTemplateStatus } from '../FormTemplate.interface';
const validationSchema = Yup.object({
    name: Yup.string().required('Required')
});
export const FormInfoCard = ({ formTemplate, onChange }) => {
    const onChangeRef = useRef(onChange); // prevent circular refresh
    const formikRef = useRef();
    const { updatedFormTemplate, isUpdating, updateError, updateFormTemplate } = useUpdateFormTemplate(formTemplate.id);
    useEffect(() => {
        var _a;
        if (updatedFormTemplate) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedFormTemplate);
        }
    }, [updatedFormTemplate]);
    const disabled = formTemplate.status === FormTemplateStatus.Published;
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null,
            React.createElement(LocalLibraryIcon, null),
            "Form Info"),
        React.createElement(CardContent, { padding: 'large' },
            React.createElement(InlineFormik, { innerRef: (formik) => (formikRef.current = formik), initialValues: {
                    name: formTemplate.name,
                    // formSchemaId: formTemplate.formSchema.id,
                    formSchemaName: formTemplate.entity.name,
                    description: formTemplate.description || ''
                }, validationSchema: validationSchema, isSubmitting: isUpdating, error: updateError, onSubmit: (formTemplateDto) => {
                    updateFormTemplate(formTemplateDto);
                } },
                React.createElement(InlineForm, null,
                    React.createElement(InlineTextField, { name: 'name', label: 'Name', placeholder: 'Provide a name for the Form.', disabled: disabled }),
                    React.createElement(InlineTextField, { name: 'formSchemaName', label: 'Form Schema', disabled: true }),
                    React.createElement(InlineTextField, { multiline: true, name: 'description', label: 'Description', placeholder: 'Provide a description of the form.', disabled: disabled }))),
            React.createElement(AppSnackbar, { severity: 'error', open: Boolean(updateError) },
                "Error occurred: ", updateError === null || updateError === void 0 ? void 0 :
                updateError.message))));
};
export default FormInfoCard;
//# sourceMappingURL=FormInfoCard.js.map